import ComparisonTable from './ComparisonTable';

export default ComparisonTable;
